<p-toolbar>
        <div class="ui-toolbar-group-left">
            <!-- <p-panel fxFlex="14" header="Salva">
                <button pButton type="button" class="editor-button" (click)="onSave()" [disabled]="disableSave">
                    <fa-icon [icon]="regularIcons.faSave" size="2x"></fa-icon>
                </button>
            </p-panel> -->
            <p-panel fxFlex="14" header="Invia">            
                <button pButton type="button" class="editor-button" (click)="onSend()" [disabled]="disableSave">
                    <fa-icon [icon]="regularIcons.faPaperPlane" size="2x"></fa-icon>
                </button>
            </p-panel>

            <p-panel fxFlex="28" header="Annul. / Riprist.">
                <div fxLayoutAlign="center center">
                    <button pButton type="button" class="editor-button" style="margin-right: 1.5rem;" (click)="onClickTool('undo', false)">
                        <fa-icon [icon]="solidIcons.faUndo" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" class="editor-button">
                        <fa-icon [icon]="solidIcons.faRedo" size="2x" (click)="onClickTool('redo', false)"></fa-icon>
                    </button>
                </div>
            </p-panel>

            <p-panel fxFlex="60" header="Zoom">
                <div fxLayoutAlign="center center">
                    <button pButton pTooltip="Zoom Finestra" tooltipPosition="bottom" type="button" class="editor-button" (click)="onClickTool('zoomSelect')">
                        <fa-icon [icon]="regularIcons.faObjectUngroup" [ngClass]="getButtonColor('zoomSelect')" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" pTooltip="Zoom" tooltipPosition="bottom" class="editor-button" style="padding-top: 0.1rem;" >
                        <div fxLayoutAlign="start start">
                            <fa-icon [icon]="solidIcons.faSearchPlus" [ngClass]="getButtonColor('zoomIn')" (click)="onClickTool('zoomIn')" size="1x"></fa-icon>
                        </div>
                        <div fxLayoutAlign="end start">
                            <fa-icon [icon]="solidIcons.faSearchMinus" [ngClass]="getButtonColor('zoomOut')" (click)="onClickTool('zoomOut')" size="1x"></fa-icon>
                        </div>                        
                    </button>
                    <button pButton type="button "pTooltip="Zoom Pan" tooltipPosition="bottom" class="editor-button" (click)="onClickTool('zoomPan')">
                        <fa-icon [icon]="solidIcons.faArrowsAlt" [ngClass]="getButtonColor('zoomPan')" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" pTooltip="Zoom Intero" tooltipPosition="bottom" class="editor-button" (click)="onClickTool('restoreZoom', false)">
                        <fa-icon [icon]="solidIcons.faExpandArrowsAlt" size="2x"></fa-icon>
                    </button>
                </div>
            </p-panel>
            <p-panel fxFlex="14" header="Seleziona">
                <button pButton type="button" class="editor-button" (click)="onClickTool('select')">
                    <fa-icon [icon]="solidIcons.faMousePointer" [ngClass]="getButtonColor('select')" size="2x"></fa-icon>
                </button>
            </p-panel>
            <p-panel fxFlex="14" header="Elimina">            
                <button pButton type="button" title="Cancella Area" class="editor-button" (click)="onClickTool('deleteSelected', false)">
                    <fa-icon [icon]="solidIcons.faEraser" size="2x"></fa-icon>
                </button>
            </p-panel>
            <p-panel fxFlex="28" header="Vertici">
                <div fxLayoutAlign="center center">
                    <button pButton type="button" pTooltip="Aggiungi Vertice" tooltipPosition="bottom" class="editor-button" (click)="onClickTool('addNode', false)">
                        <fa-icon [icon]="solidIcons.faChevronLeft" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" pTooltip="Elimina Vertice" tooltipPosition="bottom" class="editor-button" (click)="onClickTool('deleteNode', false)">
                        <fa-icon [icon]="solidIcons.faChevronRight" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" pTooltip="Modifica Perimetro" tooltipPosition="bottom" class="editor-button" (click)="onClickTool('editPolygon', false)">
                        <fa-icon [icon]="solidIcons.faVectorSquare" [ngClass]="getButtonColor('')" size="2x"></fa-icon>
                    </button>
                </div>
            </p-panel>
            <p-panel fxFlex="28" header="Disegna">
                <div fxLayoutAlign="center center">
                    <button pButton type="button" pTooltip="Poligono" tooltipPosition="bottom" class="editor-button" style="margin-right: 1.5rem;" (click)="onClickTool('drawPolygon')">
                        <fa-icon [icon]="solidIcons.faDrawPolygon" [ngClass]="getButtonColor('drawPolygon')" size="2x"></fa-icon>
                    </button>
                    <button pButton type="button" pTooltip="Rettangolo" tooltipPosition="bottom"  class="editor-button" (click)="onClickTool('square')">
                        <fa-icon [icon]="solidIcons.faVectorSquare" [ngClass]="getButtonColor('square')" size="2x"></fa-icon>
                    </button>
                </div>
            </p-panel>
        </div>
        
        <div class="ui-toolbar-group-right">
            <p-panel fxFlex="80" header="Scala">
                <div fxLayout="row">
                    <div fxFlex="16" fxLayout="column">
                        <p-radioButton name="scala" value="200" [(ngModel)]="scale" label="200" (ngModelChange)="onChangeScale()"></p-radioButton>
                        <p-radioButton name="scala" value="500" [(ngModel)]="scale" label="500" (ngModelChange)="onChangeScale()"></p-radioButton>
                    </div>
                    <div fxLayout="column" fxFlex="70" style="margin-left: 2rem">
                        <p-dropdown [options]="scaleOptions" [(ngModel)]="scale" (ngModelChange)="onChangeScale()"></p-dropdown>
                    </div>
                </div>
            </p-panel>
            <p-panel fxFlex="18" header="Stampa">
                <button  pButton type="button" class="editor-button" (click)="onClickTool('print')">
                    <fa-icon [icon]="solidIcons.faPrint" size="2x"></fa-icon>
                </button>
            </p-panel>
        </div>
    </p-toolbar>